<template>
    <div id="aulas">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                <img :src="Login" style="width:98%; box-shadow:none">
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">
                <br>
                <br><br>

                <el-row :gutter="20">
                    <el-col :xs="24" :sm="8" style="margin-bottom:30px" align="center">
                        <strong>Capacitaciones</strong>
                        <router-link :to="'/capacitaciones'">
                            <img :src="Capacitaciones" style="width:100%" class="pautas">
                        </router-link>
                    </el-col>
                    <el-col :xs="24" :sm="8" style="margin-bottom:30px" align="center">
                        <strong>Aulas Virtuales</strong>
                        
                            <img :src="Aulas" style="width:100%" class="pautas">
                        
                    </el-col>
                    <el-col :xs="24" :sm="8" style="margin-bottom:30px" align="center">
                        <strong>Protocolo Reglamentario</strong>
                     
                            <img :src="Pautas" style="width:100%" class="pautas">
                       
                    </el-col>

                    <!--
                    <el-col :span="24" style="font-size:large; background:#FFE500; width:100%; padding:20px; margin-top:30px">
                        <div align="center">
                            <span style="font-size:30px; color:#FF4C00">
                                <strong>Consulte por su certificado en la dirección oferente encargada de la capacitación.</strong>
                            </span>
                        </div>
                        <hr>
                        <div align="justify" style="color:#FF4C00">
                            El trámite es personal y deberá asistir con su <strong>DNI</strong>. Si lo realiza un tercero, deberá
                            presentarse con <strong>fotocopia del DNI</strong> del titular y nota  de <strong>autorización firmada
                            </strong> por el mismo.
                        </div>
                    </el-col>
                    -->
                </el-row>

  <!--               <el-row :gutter="20" v-if="!DniDigital" style="margin-top:30px">
                    <el-col :span="24" style="font-size:large; background:red; width:100%; padding:20px">
                        <div align="center" style="color:#FFF">
                            Por favor adjunte una copia digital de su DNI (<small>de lo contrario no podrá
                            recibir certificados de sus cursos realizados</small>).
                            <br>
                            Haga click <router-link :to="'editar/dni'"><strong>aquí</strong></router-link>.
                        </div>
                    </el-col>
                </el-row> -->

            </el-col>
        </el-row>
    </div>
</template>


<script>
   /* import axios from 'axios';*/

    export default
    {   data()
        {   return {
                DniDigital:     '',
                Login:          'https://docentes.educaciondigitaltuc.gob.ar/assets/login.png',
                Capacitaciones: 'https://docentes.educaciondigitaltuc.gob.ar/assets/capacitaciones.png',
                Aulas:          'https://docentes.educaciondigitaltuc.gob.ar/assets/aulas.png',
                Pautas:         'https://docentes.educaciondigitaltuc.gob.ar/assets/pautas.png',

                Headers: [{
                        text: 'Código ',
                        value: 'idComision'
                    },
                    {
                        text: 'Capacitación ',
                        value: 'Nombre'
                    },
                    {
                        text: 'Responder',
                        value: 'Respondida'
                    }
                ],
            }
        },
/*
        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                    .then(response => {
                        const datos     = response.data
                        this.DniDigital = datos['dni'];
                        if(!datos['Notificado'])
                        {
                            this.$router.push('/validar_datos');    
                        }
                        
                        if(datos['personales']['Nacimiento']=='00/00/0000') this.$router.push('/editar/personales');
                        if(datos['personales']['Sexo']=='')                 this.$router.push('/editar/personales');
                        if(datos['clave'])                                  this.$router.push('/pass');
                        if(datos['validar'])                                this.$router.push('/datos');
                    })
                    .catch(e => {})
            }
        }*/
    };
</script>


<style>
    .pautas
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }

    .pautas:hover
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
        -webkit-box-shadow: 0px 10px 20px 0px rgba(50, 50, 50, 0.75);
        -moz-box-shadow:    0px 10px 20px 0px rgba(50, 50, 50, 0.75);
        box-shadow:         0px 10px 20px 0px rgba(50, 50, 50, 0.75);
    }

    .TablaEncuesta .theme--light.v-datatable .v-datatable__actions 
    {   display: none;
    }
</style>
